import { useState } from 'react'
    // Pagination has been added - 16/09/24 - Dev Srini
import {
    Typography, Tabs, Tab, TableContainer, Table, TableRow, TableHead, TableCell, TableBody, Collapse,
    Button, TablePagination, Grid // srini - 21/11/24
} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import dayjs from 'dayjs'
// importing package - srini - 21/11/24
import exportFromJSON from 'export-from-json'

import { apiUrl } from '../../../../../ui-utils/apiConfig'
import { backendHosts } from '../../../../../ui-utils/apiConfig'
import styles from '../dashboardStyles'

import Vector1 from '../../../../../ui-assets/Vector1.svg'

// srini - 11/11/24
import CallLogs from '../CallLogs/CallLogs'
import CallLogsTable from '../CallLogs/CallLogsTable'
import AdminReport from '../AdminReport/AdminReport'
import ReportTable from '../AdminReport/ReportTable'
// importing component - srini - 21/11/24
import DialogBox from '../../../../Dialog Box/DialogBox'

const TableDisplay = ({
    classes,
    callHistoryChat,
    tabId,
    dispatch,
    customerPendingTasks,
    handleTabChange,
    callLogs,
    playBackAudio,
    handleCallForm
}) => {

    const [expandedRow, setExpandedRow] = useState(null)
    const [isToggle, setIsToggle] = useState(false)

    const [sortColumn, setSortColumn] = useState(null)
    const [sortDirection, setSortDirection] = useState('asc')

    const [playing, setPlaying] = useState(null)

    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    // srini - 21/11/24
    const [dailBoxOpen, setDailBoxOpen] = useState(false)
    const [selectedCustNumber, setSelectedCustNumber] = useState(null) // Srini - 05/12/24

    // srini - 17/01/25
    const agentRole = JSON.parse(localStorage.getItem('agentRole'))

    const handleToggleExpand = (index) => {
        setExpandedRow(expandedRow === index ? null : index)
        setIsToggle(!isToggle)
    }

    const currentDateTime = new Date()

    const filteredTasks = customerPendingTasks.filter(task => {
        const followupDateTime = new Date(task.followup_datetime)
        return followupDateTime >= currentDateTime
    })

    filteredTasks.sort((a, b) => new Date(a.followup_datetime) - new Date(b.followup_datetime))

    // For past dates
    const pastTasks = customerPendingTasks.filter(task => {
        const followupDateTime = new Date(task.followup_datetime)
        return followupDateTime < currentDateTime
    })

    pastTasks.sort((a, b) => new Date(b.followup_datetime) - new Date(a.followup_datetime))

    const finalTasks = [...filteredTasks, ...pastTasks]

    const handleSort = (column) => {
        if (sortColumn === column) {
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc')
        } else {
            setSortColumn(column)
            setSortDirection('asc')
        }
    }

    finalTasks.sort((a, b) => {
        if (sortColumn === 'task_datetime' || sortColumn === 'followup_datetime' || sortColumn === 'call_datetime') {
            const dateA = new Date(a[sortColumn])
            const dateB = new Date(b[sortColumn])

            if (sortDirection === 'asc') {
                return dateA - dateB
            } else {
                return dateB - dateA
            }
        } else {
            return 0
        }
    })

    callLogs.sort((a, b) => {
        if (sortColumn === 'call_datetime') {
            const dateA = new Date(a[sortColumn])
            const dateB = new Date(b[sortColumn])

            if (sortDirection === 'asc') {
                return dateA - dateB
            } else {
                return dateB - dateA
            }
        } else {
            return 0
        }
    })


    const getFollowUpStatus = (followupDateTime) => {
        const followupDate = new Date(followupDateTime)
        const currentDate = new Date()
        const yesterday = new Date()
        yesterday.setDate(yesterday.getDate() - 1) // Set date to yesterday

        const diffInMinutes = Math.floor((followupDate - currentDate) / (1000 * 60))
        if (diffInMinutes > 60) {
            if (diffInMinutes < 24 * 60) {
                return `${Math.floor(diffInMinutes / 60)} Hours`
            } else {
                // const diffInHours = Math.floor(diffInMinutes / 60)
                // return `${Math.floor(diffInHours / 24)} days ${diffInHours % 24} hours`
                return 'Later'

            }
        } else if (diffInMinutes > 0) {
            return `${diffInMinutes} Mins`
        } else if (followupDate <= yesterday) {
            return 'Long Wait'
        } else if (followupDate > new Date(currentDate.getTime() + 24 * 60 * 60 * 1000)) {
            return 'Later'
        } else if (followupDate.getDate() === currentDate.getDate() + 1) {
            return 'Tomorrow onwards'
        } else {
            return 'Long Wait' // Assuming other past dates should also be 'expired'
        }
    }

    const playPauseCallRecord = async (audioFile, index) => {

        if (playing === index) {
            playBackAudio.pause()
            setPlaying(null)
            playBackAudio.src = null
        } else {
            let audio_path = `${backendHosts.CRM}${apiUrl.audioFile}/${audioFile}`
            
            try {
                const result = await fetch(audio_path, {
                    headers: {
                        Authorization: localStorage.getItem('token')
                    }
                })

                const blob = await result.blob()
                if (blob) {
                    playBackAudio.src = URL.createObjectURL(blob)
                }
                playBackAudio.play()
                setPlaying(index)
            } catch (error) {
                console.error('Error fetching or playing audio:', error)
            }
        }

        playBackAudio.onended = () => setPlaying(null) // Reset when audio ends
    }

    const  handlePageChange = (event, newpage) => { 
        setPage(newpage)
    }
    // srini - 11/11/24
    const handleRowsPerPageChange =(event) => { 
        setRowsPerPage(+event.target.value)
        setPage(0)
    } 
    // download file - srini - 21/11/24
    const handleDownloadCsv = () => {
        const header = ['Task ID', 'Date&Time', 'Customer Email', 'Customer Number', 'Description', 'Comments', 'Follow Up Date/Time', 'Updated on', 'Updated By']
    
        const filteredTasks = finalTasks.filter(item => {
            if (tabId === 0) {
                return item.status === 'Pending with me'
            } else if (tabId === 1) {
                return item.status === 'Pending with others'
            }
            return false
        })

        const getFormattedDateTime = (updatedon) => {
            if (!updatedon) return '-'
        
            let dateObj
            if (updatedon.includes('T')) {
                dateObj = new Date(updatedon)
            } else if (updatedon.includes(' ')) {
                const [date, time] = updatedon.split(' ')
                dateObj = new Date(`${date}T${time}`)
            }
        
            if (isNaN(dateObj.getTime())) {
                return '-'
            }
        
            const formattedDate = dateObj.toISOString().split('T')[0]
            const formattedTime = dateObj.toISOString().split('T')[1].split('.')[0]
            
            return `${formattedDate} - ${formattedTime}`
        }
    
        
        const data = filteredTasks.flatMap(item => {
            const sortedTasks = [...item.task].sort((a, b) => new Date(a.updatedon) - new Date(b.updatedon))
            const comments = sortedTasks.map(task => task.comment || '')
            const rows = []
            
            const formattedDateTime = item.task_datetime ? item.task_datetime.split(' ')[0] + ' - ' + item.task_datetime.split(' ')[1]?.split('.')[0] : '-'

            const updatedDateTime = getFormattedDateTime(item.updatedon)
            
            if (comments.length > 0) {
                const firstTask = sortedTasks[0]
                const firstFollowUpDateTime = firstTask.followup_date && firstTask.followup_time ? `${firstTask.followup_date?.split(" ")[0]} ${firstTask.followup_time}` : '-'
                
                rows.push({
                    [header[0]]: `Task_${item.uid}`,
                    [header[1]]: formattedDateTime, 
                    [header[2]]: `${item.customer_email}`,
                    [header[3]]: `${item.customer_number}`,
                    [header[4]]: `${firstTask.call_description || ''}`,
                    [header[5]]: comments[0], 
                    [header[6]]: firstFollowUpDateTime,
                    [header[7]]: updatedDateTime,
                    [header[8]]: `${item.updatedby || ''}`,
                })
            }
            
            comments.slice(1).forEach((comment, index) => {
                const updatedTask = sortedTasks[index + 1]
                const updatedFollowUpDateTime = updatedTask.followup_date && updatedTask.followup_time ? `${updatedTask.followup_date?.split(" ")[0] || "-"} ${updatedTask.followup_time}` : '-'

                const updatedTaskDateTime = getFormattedDateTime(updatedTask.updatedon)

                rows.push({
                    [header[0]]: `Task_${item.uid}`,
                    [header[1]]: updatedTaskDateTime,
                    [header[2]]: `${item.customer_email}`,
                    [header[3]]: `${item.customer_number}`,
                    [header[4]]: updatedTask.call_description,
                    [header[5]]: `Follow up ${index + 1} - ${comment}`,
                    [header[6]]: updatedFollowUpDateTime,
                    [header[7]]: updatedTaskDateTime,
                    [header[8]]: `${updatedTask.updatedby || ''}`,
                })
            })
    
            return rows
        })
    
        const fileName = tabId === 0 ? 'Pending with me Report' : tabId === 1 ? 'Pending with others Report' : 'Report'
        const exportType = exportFromJSON.types.csv
        exportFromJSON({ data, fileName, exportType })
    }

    const handleClickOpen = (number) => {
        setDailBoxOpen(true)
        setSelectedCustNumber(number) // Srini - 05/12/24
    }

    const handleClose = () => {
        setDailBoxOpen(false)
    }
    
    return (
        <div >
            <Typography
                className={classes.dashboardText2}
                style={{ color: '#FFFFFF', margin: '7% 0 0 0' }}
            >Dashboard</Typography>

            <Typography className={classes.todo_list} style={{ color: '#CEFEB8', margin: '2% 0 0 0' }}>To Do List  </Typography>

            {/* srini - 21/11/24 */}
            <Grid container alignItems='flex-end'>
                <Grid item xs={10}>
                    <Tabs value={tabId} onChange={handleTabChange} variant="standard" classes={{ indicator: classes.indicator }}
                        indicatorColor="primary" style={{ margin: '1% 0 0 0' }} >
                        <Tab
                            value={0}
                            className={classes.pending_heading}
                            label="Pending with me"
                            style={{
                                borderBottom: tabId !== 0 ? '2px solid #131E2E' : '2px solid #F3D45E',
                            }}
                        />
                        <Tab
                            value={1}
                            className={classes.pending_heading2}
                            label="Pending with others"
                            style={{
                                borderBottom: tabId !== 1 ? '2px solid #131E2E' : '2px solid #F3D45E',
                            }}
                        />
                        <Tab
                            value={2}
                            className={classes.pending_heading2}
                            label="Call Logs"
                            style={{
                                borderBottom: tabId !== 2 ? '2px solid #131E2E' : '2px solid #F3D45E',
                            }}
                        />
                        {/* srini - 17/01/25 */}
                        {!(agentRole.includes(2) || agentRole.includes(4)) && <Tab
                            value={3}
                            className={classes.pending_heading2}
                            label="Admin Report"
                            style={{
                                borderBottom: tabId !== 3 ? '2px solid #131E2E' : '2px solid #F3D45E',
                            }}
                        />}
                    </Tabs>
                </Grid>
                {(tabId === 0 || tabId === 1) && <Grid item xs={2} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                        style={{
                            color: "#F3D45E",
                            textDecoration: "underline",
                            fontFamily: 'cardiuma-regular',
                            fontSize: '13px',
                            fontStyle: 'normal',
                            fontWeight: 'bold',
                        }}
                    onClick={handleDownloadCsv}
                    >
                        Download CSV
                    </Button>
                </Grid>}
            </Grid>

            <div style={{ margin: '1% 0 0 0' }}>
                {/* srini - 17/01/25 */}
                {tabId === 2 && <CallLogs dispatch={dispatch} callLogs={callLogs} />}
                {!(agentRole.includes(2) || agentRole.includes(4)) && tabId === 3 && <AdminReport dispatch={dispatch} callLogs={callLogs} />
            }
            </div>

            <div style={{
                width: '100%',
                height: 'auto',
                flexShrink: 0,
                borderRadius: '10px',
                background: '#131E2E',
                overflowY: 'auto',
                margin: '18px 0px 0px 0px'
            }}
            >
                <TableContainer >
                    <Table aria-label="simple table">
                         {/*srini - 11/11/24  */}
                            <TableHead>
                                <TableRow style={{ borderBottom: '2px solid Black' }} >
                                    {(tabId == 2 || tabId == 3) && <TableCell className={classes.tableHeading} align="left"> Audio / Form </TableCell>}

                                    <TableCell
                                        className={classes.tableHeading}
                                        align="left"
                                        onClick={() => handleSort(tabId === 2 ? 'call_datetime' : 'task_datetime')}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        Date & Time {((sortColumn === 'task_datetime' || sortColumn === 'call_datetime') && sortDirection === 'asc') ? '▼' : '▲'}
                                    </TableCell>


                                    {(tabId == 2 || tabId == 3) && <TableCell className={classes.tableHeading} align="left"> ID / Name </TableCell>}

                                    {(tabId == 2 || tabId == 3) && <TableCell className={classes.tableHeading} align="left"> Duration / Bill <br /> (In Seconds) </TableCell>}

                                    {(tabId == 2 || tabId == 3) ? <TableCell className={classes.tableHeading} align="left">Customer <br /> Number / Name </TableCell> : <TableCell className={classes.tableHeading} align="left">Customer Email & Number</TableCell>}
                                    {/* new column - srini - 28/11/24 */}
                                    {(tabId == 2 || tabId == 3) && <TableCell className={classes.tableHeading} align="left">Customer <br /> ID / Email </TableCell>}

                                    {(tabId == 0 || tabId == 1) && <TableCell className={classes.tableHeading} align="left">Description</TableCell>}

                                    {(tabId == 2 || tabId == 3) ? <TableCell className={classes.tableHeading} align="left">Status</TableCell> : <TableCell
                                        className={classes.tableHeading}
                                        align="left"
                                        onClick={() => handleSort('followup_datetime')}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        Follow Up Date & Time {sortColumn === 'followup_datetime' && sortDirection === 'asc' ? '▼' : '▲'}
                                    </TableCell>}

                                    {(tabId == 2 || tabId == 3) && <TableCell className={classes.tableHeading} align="left">Call state</TableCell>}

                                    {(tabId !== 2 && tabId !== 3) && <TableCell className={classes.tableHeading} align="center">Action</TableCell>}
                                    {/* srini - 11/11/24 */}
                                    {(tabId == 3) && <TableCell 
                                    className={classes.tableHeading}
                                    align="center">Call Description</TableCell>}

                                    {(tabId == 3) && <TableCell 
                                    className={classes.tableHeading}  style={{ display: 'flex', justifyContent: 'center', width: '200px', border: 'none' }}
                                    align="center" >Comments</TableCell>}

                                    {(tabId == 3) && <TableCell className={classes.tableHeading} align="center">Pending By</TableCell>}

                                    {(tabId == 3) && <TableCell className={classes.tableHeading} align="center">State</TableCell>}

                                    {(tabId == 3) && <TableCell className={classes.tableHeading} align="center">City</TableCell>}

                                    {(tabId == 3) && <TableCell className={classes.tableHeading} align="center">Created <br /> By / On</TableCell>}

                                    {(tabId == 3) && <TableCell className={classes.tableHeading} align="center">Updated <br /> By / On</TableCell>}

                                    {(tabId == 3) && <TableCell className={classes.tableHeading} align="center">Follow Up <br /> Date / Time</TableCell>}

                                </TableRow>
                            </TableHead>
                        
                        {tabId === 0 ?
                            <TableBody>
                                {finalTasks.filter(item => item.status === 'Pending with me').slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((item, index) => (
                                    <Grid key={index}>
                                        <TableRow
                                            style={{
                                                borderBottom: expandedRow === index ? '2px solid #162740' : '2px solid Black',
                                                background: expandedRow === index ? '#162740' : '#131E2E'
                                            }}
                                        >

                                            <TableCell
                                                align="left"
                                                className={classes.rowtext}
                                                onClick={() => {
                                                    handleToggleExpand(index)
                                                    dispatch({
                                                        type: 'SET_CALL_HISTORY_CHAT',
                                                        payload: item.task
                                                    })
                                                }}
                                            >
                                                {item.task_datetime.split(' ')[0]} <br />
                                                {item.task_datetime.split(' ')[1].split('.')[0]}
                                            </TableCell>

                                            <TableCell
                                                align="left"
                                                className={classes.rowtext}
                                                onClick={() => {
                                                    handleToggleExpand(index)
                                                    dispatch({
                                                        type: 'SET_CALL_HISTORY_CHAT',
                                                        payload: item.task
                                                    })
                                                }}
                                            >
                                                {item.customer_email} <br />
                                                {item.customer_number}
                                            </TableCell>

                                            <TableCell
                                                align="left"
                                                className={classes.rowtext}
                                                onClick={() => {
                                                    handleToggleExpand(index)
                                                    dispatch({
                                                        type: 'SET_CALL_HISTORY_CHAT',
                                                        payload: item.task
                                                    })
                                                }}
                                            >
                                                {item.description}
                                            </TableCell>

                                            <TableCell
                                                align="left"
                                                className={classes.rowtext}
                                                onClick={() => {
                                                    handleToggleExpand(index);
                                                    dispatch({
                                                        type: 'SET_CALL_HISTORY_CHAT',
                                                        payload: item.task
                                                    });
                                                }}
                                            >
                                                {item?.followup_datetime && (
                                                    <>
                                                        {item.followup_datetime.split(' ')[0]} <br />
                                                        {item.followup_datetime.split(' ')[1]}
                                                        <span style={{ marginLeft: '22%' }} className={getFollowUpStatus(item.followup_datetime) === 'Later' ? classes.statusLater : getFollowUpStatus(item.followup_datetime) === 'Long Wait' ? classes.statusExpiry : classes.statusPending}>
                                                            {getFollowUpStatus(item.followup_datetime)}
                                                        </span>
                                                    </>
                                                )}
                                            </TableCell>
{/* removed handleStartCall function here from app level - 21-11-24 - Dev Srini */}

                                            <TableCell align="center" onClick={() => handleClickOpen(item.customer_number)}>
                                                <img src={Vector1} alt='phone icon' />
                                            </TableCell>
                                            {/* srini - 21/11/24 */}
                                            <DialogBox open={dailBoxOpen} handleClose={handleClose} customerNumber={selectedCustNumber} dispatch={dispatch} />
                                        </TableRow>

                                        {expandedRow === index && (
                                            <TableRow style={{ padding: 0, margin: 0 }}>
                                                <TableCell colSpan={5} style={{ padding: 0, margin: 0 }}>
                                                    <Collapse in={expandedRow === index} timeout="auto" unmountOnExit>
                                                        <div style={{
                                                            backgroundColor: '#162740',
                                                            paddingBottom: '2%'
                                                        }}>
                                                            <Typography style={{
                                                                color: '#999',
                                                                fontFamily: 'cardiuma-regular',
                                                                fontSize: '11px',
                                                                fontStyle: 'normal',
                                                                fontWeight: '400',
                                                                lineHeight: 'normal',
                                                                margin: '0 0 0 2%',

                                                            }}>Call History</Typography>

                                                            {callHistoryChat.sort((a, b) => {
                                                                return new Date(b.updatedon) - new Date(a.updatedon)
                                                            }).map((ele, i) => (
                                                                <div key={i}>
                                                                    <div style={{
                                                                        width: '95%',

                                                                        flexShrink: 0,
                                                                        borderRadius: '4px',
                                                                        border: '1px solid #0B1420',
                                                                        background: '#131E2E',
                                                                        margin: '10px 0px 0px 15px',
                                                                        display: 'flex',
                                                                        flexDirection: 'column'
                                                                    }}>
                                                                        <div style={{
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            margin: '10px 15px 15px 10px'
                                                                        }}>
                                                                            <span className={classes.callhistoryrecords} style={{ marginLeft: '15px' }}>
                                                                                {ele.call_description}
                                                                            </span>
                                                                            <span style={{ marginLeft: 'auto' }} className={classes.datetext1}>
                                                                                {dayjs(ele.updatedon).format("DD/MM/YY HH : mm a")}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    <div style={{
                                                                        width: '95%',
                                                                        height: 'auto',
                                                                        flexShrink: 0,
                                                                        borderRadius: '4px',
                                                                        border: '1px solid #0B1420',
                                                                        background: '#131E2E',
                                                                        margin: '12px 0px 0px 16px',
                                                                        display: 'flex',
                                                                        flexDirection: 'column'
                                                                    }}>
                                                                        <span style={{ alignSelf: 'flex-end', margin: '0px 15px 0px 0px' }} className={classes.datetext1}>
                                                                            {dayjs(ele.updatedon).format("DD/MM/YY HH : mm a")}
                                                                        </span>
                                                                        <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end', margin: '0px 12px 15px 10px' }}>
                                                                            <span className={classes.callhistoryrecords}>{ele.comment}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </Collapse>
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </Grid>
                                ))}
                            </TableBody> : tabId === 1 ? <TableBody>
                                {finalTasks.filter(item => item.status === 'Pending with others').slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((item, index) => (
                                    <Grid key={index}>
                                        <TableRow
                                            style={{
                                                borderBottom: expandedRow === index ? '2px solid #162740' : '2px solid Black',
                                                background: expandedRow === index ? '#162740' : '#131E2E'
                                            }}
                                        >
                                            <TableCell
                                                align="left"
                                                className={classes.rowtext}
                                                onClick={() => {
                                                    handleToggleExpand(index)
                                                    dispatch({
                                                        type: 'SET_CALL_HISTORY_CHAT',
                                                        payload: item.task
                                                    })
                                                }}
                                            >{item.task_datetime.split(' ')[0]} <br />
                                                {item.task_datetime.split(' ')[1].split('.')[0]}
                                            </TableCell>

                                            <TableCell
                                                align="left"
                                                className={classes.rowtext}
                                                onClick={() => {
                                                    handleToggleExpand(index)
                                                    dispatch({
                                                        type: 'SET_CALL_HISTORY_CHAT',
                                                        payload: item.task
                                                    })
                                                }}
                                            >{item.customer_email} <br />
                                                {item.customer_number}
                                            </TableCell>

                                            <TableCell
                                                align="left"
                                                className={classes.rowtext}
                                                onClick={() => {
                                                    handleToggleExpand(index)
                                                    dispatch({
                                                        type: 'SET_CALL_HISTORY_CHAT',
                                                        payload: item.task
                                                    })
                                                }}
                                            >{item.description}
                                            </TableCell>

                                            <TableCell
                                                align="left"
                                                className={classes.rowtext}
                                                onClick={() => {
                                                    handleToggleExpand(index);
                                                    dispatch({
                                                        type: 'SET_CALL_HISTORY_CHAT',
                                                        payload: item.task
                                                    });
                                                }}
                                            >
                                                {item?.followup_datetime && (
                                                    <>
                                                        {item.followup_datetime.split(' ')[0]} <br />
                                                        {item.followup_datetime.split(' ')[1]}
                                                        <span style={{ marginLeft: '22%' }} className={getFollowUpStatus(item.followup_datetime) === 'Later' ? classes.statusLater : getFollowUpStatus(item.followup_datetime) === 'Long Wait' ? classes.statusExpiry : classes.statusPending}>
                                                            {getFollowUpStatus(item.followup_datetime)}
                                                        </span>
                                                    </>
                                                )}
                                            </TableCell>


                                            <TableCell
                                                align="center"
                                                onClick={() => handleClickOpen(item.customer_number)}

                                            >
                                                <img src={Vector1} alt='phone icon' style={{ width: '13.36px', height: '13.361px', flexShrink: 0 }} />
                                            </TableCell>
                                            {/* render - srini - 21/11/24 */}
                                            <DialogBox open={dailBoxOpen} handleClose={handleClose} customerNumber={selectedCustNumber} dispatch={dispatch} />
                                        </TableRow>

                                        {expandedRow === index && (
                                            <TableRow style={{ padding: 0, margin: 0 }}>
                                                <TableCell colSpan={6} style={{ padding: 0, margin: 0 }}>
                                                    <Collapse in={expandedRow === index} timeout="auto" unmountOnExit>
                                                        <div style={{
                                                            backgroundColor: '#162740',
                                                            paddingBottom: '2%'
                                                        }}>
                                                            <Typography style={{
                                                                color: '#999',
                                                                fontFamily: 'cardiuma-regular',
                                                                fontSize: '11px',
                                                                fontStyle: 'normal',
                                                                fontWeight: '400',
                                                                lineHeight: 'normal',
                                                                margin: '0 0 0 2%',

                                                            }}>Call History</Typography>

                                                            {callHistoryChat.sort((a, b) => {
                                                                return new Date(b.updatedon) - new Date(a.updatedon)
                                                            }).map((ele, i) => (
                                                                <div key={i}>
                                                                    <div style={{
                                                                        width: '95%',

                                                                        flexShrink: 0,
                                                                        borderRadius: '4px',
                                                                        border: '1px solid #0B1420',
                                                                        background: '#131E2E',
                                                                        margin: '10px 0px 0px 15px',
                                                                        display: 'flex',
                                                                        flexDirection: 'column'
                                                                    }}>
                                                                        <div style={{
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            margin: '10px 15px 15px 10px'
                                                                        }}>
                                                                            <span className={classes.callhistoryrecords} style={{ marginLeft: '15px' }}>
                                                                                {ele.call_description}
                                                                            </span>
                                                                            <span style={{ marginLeft: 'auto' }} className={classes.datetext1}>
                                                                                {dayjs(ele.updatedon).format("DD/MM/YY HH : mm a")}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    <div style={{
                                                                        width: '95%',
                                                                        height: 'auto',
                                                                        flexShrink: 0,
                                                                        borderRadius: '4px',
                                                                        border: '1px solid #0B1420',
                                                                        background: '#131E2E',
                                                                        margin: '12px 0px 0px 16px',
                                                                        display: 'flex',
                                                                        flexDirection: 'column'
                                                                    }}>
                                                                        <span style={{ alignSelf: 'flex-end', margin: '0px 15px 0px 0px' }} className={classes.datetext1}>
                                                                            {dayjs(ele.updatedon).format("DD/MM/YY HH : mm a")}
                                                                        </span>
                                                                        <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end', margin: '0px 12px 15px 10px' }}>
                                                                            <span className={classes.callhistoryrecords}>{ele.comment}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </Collapse>
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </Grid>
                                ))}
                            </TableBody> : tabId === 2 ? <CallLogsTable 
                                classes={classes}
                                callLogs={callLogs}
                                playPauseCallRecord={playPauseCallRecord}
                                playing={playing}
                                handleCallForm={handleCallForm}
                                page={page}
                                rowsPerPage={rowsPerPage}
                            /> : <ReportTable 
                                callLogs={callLogs}
                                playPauseCallRecord={playPauseCallRecord}
                                playing={playing}
                                handleCallForm={handleCallForm}
                                classes={classes}
                                page={page}
                                rowsPerPage={rowsPerPage}
                                />
                            }
                    </Table>
                </TableContainer>
                {<TablePagination
                    className={classes.pagination}
                    rowsPerPageOptions={[10, 25, 50]}
                    component="div"
                    count={tabId == 0 ? finalTasks.filter(item => item.status === 'Pending with me').length : tabId == 1 ? finalTasks.filter(item => item.status === 'Pending with others').length : callLogs.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handlePageChange}
                    onRowsPerPageChange={handleRowsPerPageChange}
                />}
            </div>
        </div>
    )
}

export default withStyles(styles)(TableDisplay)